import React, { useState } from "react";
import Blocks from "./Blocks";
import { Card, CardContent } from '@/components/ui/card';
import { Heading, Text } from '@/components/ui/typography';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { useNavigate } from "react-router";

const CandidateListPage = ({ ranking, jobDetails }) => {
  const navigate = useNavigate();
  const jobId = new URLSearchParams(window.location.search).get("jobID");

  const [currentPage, setCurrentPage] = useState(1);
  const candidatesPerPage = 5; // Adjust number of candidates per page

  // Calculate total pages
  const totalPages = Math.ceil(ranking.length / candidatesPerPage);

  // Get current candidates for the page
  const indexOfLastCandidate = currentPage * candidatesPerPage;
  const indexOfFirstCandidate = indexOfLastCandidate - candidatesPerPage;
  const currentCandidates = ranking.slice(indexOfFirstCandidate, indexOfLastCandidate);

  // Handle navigation between pages
  const goToNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const goToPreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleCardClick = (index) => {
    navigate(`/reports?jobID=${jobId}`, { state: { candidate: currentCandidates[index], jobDetails } });
  };

  return (
    <>
      <div className="flex justify-between gap-5 w-[70%] p-5">
        <div className="bg-white w-[80%]">
          <Heading level="h2" className="text-2xl font-bold mb-5 text-foreground">Candidates Results</Heading>
          <div className="flex flex-col items-center gap-5">
            {currentCandidates.map((candidate, index) => (
              <Card key={index} className="w-full bg-white rounded-lg shadow-md p-5 border-l-4 border-[#4e73df] cursor-pointer hover:shadow-lg transition-shadow" onClick={() => handleCardClick(index)}>
                <CardContent className="p-0">
                  <div className="w-full flex justify-between items-center gap-5">
                    <div className="flex flex-wrap items-center gap-4">
                      <img src="user.jpg" alt="Avatar" className="w-20 h-20 rounded-full" />
                      <div>
                        <Heading level="h3" className="text-xl font-semibold mb-2">{candidate.details.name}</Heading>
                        <Text className="text-sm mb-1">Experience: {candidate.details.experience} years</Text>
                        <Text className="text-sm mb-1 truncate max-w-xs" title={candidate.details?.qualification || ''}>
                          Qualification: {candidate.details?.qualification
                            ? candidate.details.qualification.length > 30
                              ? candidate.details.qualification.slice(0, 30) + "..."
                              : candidate.details.qualification
                            : null}
                        </Text>
                        <Text className="text-sm font-semibold text-primary">{candidate.details.screening_score}% Overall Score</Text>
                      </div>
                    </div>

                    <div className="flex gap-2">
                      {candidate.scores.map((score, scoreIndex) => (
                        <div key={scoreIndex} className="flex flex-col items-center gap-1">
                          <img src={score.icon} alt="Score icon" className="w-8 h-8" loading="lazy" />
                          <Text className="text-xs">{score.score ?? 'Not Given'}</Text>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="flex gap-2 mt-4">
                    <Button variant="outline" className="text-sm">View Resume</Button>
                    <Button variant="outline" className="text-sm" onClick={(e) => { e.stopPropagation(); handleCardClick(index); }}>View Detailed Result</Button>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
          {/* Pagination Controls */}
          <div className="flex gap-2 justify-center items-center mt-6">
            <Button variant="outline" size="sm" onClick={goToPreviousPage} disabled={currentPage === 1}>
              ◀
            </Button>
            <Text className="mx-4">{currentPage} / {totalPages}</Text>
            <Button variant="outline" size="sm" onClick={goToNextPage} disabled={currentPage === totalPages}>
              ▶
            </Button>
          </div>
        </div>
        <Blocks scores={ranking} />
      </div>
    </>
  );
};

export default CandidateListPage;
